import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

// components
import CommonInput from "../../components/input/CommonInput";

// validation
import { validationFunc } from "../../validation/validation";

// api
import { resetPassword } from "../../services/api/user";

function ResetPWPage() {
    const navigate = useNavigate();
    const { state } = useLocation();

    const [input, setInput] = useState({
        password: ""
    });

    const [validation, setValidation] = useState(false);

    const handleInput = (value, type) => {

        if(type==="password"){
            setValidation(validationFunc({ input:value, minLength:8, isNumber:true, isAlphabet:true, isSpecChars:true, isPassword:true}))
        }

        setInput({
            [type]: value
        })
    }

    const handleClickResetPasswordButton = async (event) => {
        event.preventDefault();

        setInput({
            password: input.password.trim()
        })
        
        try{
            const data = {
                email: state,
                password: input.password.trim()
            }
            const res = await resetPassword(data);
            navigate("/forgot-password/reset-successful");
        }catch(err){
            console.error(err);
        }        
    }

    return (
        <form className="ResetPWPage">
            <div className="Title">
                Reset your password
            </div>
            <div className="Description">
                <div>
                    Please set the password
                </div>
                <div>
                    you want to change.
                </div>
            </div>
            <div className="Input">
                <CommonInput
                    type="password"
                    legend="Password"
                    placeholder="Enter new password."
                    handleInput={handleInput}
                    input={input}
                    description={`Passwords must meet the following criteria: 8+ digits / contain numbers / contain alphanumeric characters / contain special characters (except \\ ").`}
                    checkvalid={true}
                    validation={validation}
                />
            </div>
            <button
                type="submit"
                className="ResetPasswordButton"
                onClick={handleClickResetPasswordButton}
                disabled={!validation}
            >
                Reset Password
            </button>
        </form>
    );
}

export default ResetPWPage;